export default {"src":"/_next/static/media/Youtube.603a5089.svg","height":37,"width":37,"blurWidth":0,"blurHeight":0};